exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nd-toast[data-v-33830de4] {\n  max-width: 70%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n  z-index: 9999;\n}\n.nd-toast p[data-v-33830de4] {\n  padding: 0.32rem 0.266667rem 0.266667rem;\n  font-size: 0.373333rem;\n  border-radius: 0.133333rem;\n  color: #FFFFFF;\n  background: rgba(0, 0, 0, 0.7);\n}", ""]);

// exports
